// extracted by mini-css-extract-plugin
export default {"root":"LoadingDots_root__VDUEK","dot":"LoadingDots_dot__1v5w0","blink":"LoadingDots_blink__8UaNr"};